import io from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:3000';

class WebSocketService {
  constructor() {
    this.socket = null;
    this.subscribers = new Map();
  }

  connect() {
    if (!this.socket) {
      this.socket = io(SOCKET_URL, {
        transports: ['websocket'],
        autoConnect: true,
      });

      this.socket.on('connect', () => {
        // console.log('WebSocket connected');
      });

      this.socket.on('disconnect', () => {
        // console.log('WebSocket disconnected');
      });

      this.socket.on('error', (error) => {
        console.error('WebSocket error:', error);
      });

      // Handle different types of updates
      this.socket.on('booking:update', (data) => {
        this.notifySubscribers('booking', data);
      });

      // Add booking processing status handler
      this.socket.on('booking:processing', (data) => {
        this.notifySubscribers('booking:processing', data);
      });

      this.socket.on('talent:update', (data) => {
        this.notifySubscribers('talent', data);
      });

      this.socket.on('availability:update', (data) => {
        this.notifySubscribers('availability', data);
      });

      this.socket.on('vacation:update', (data) => {
        this.notifySubscribers('vacation', data);
      });
    }
    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  subscribe(type, callback) {
    if (!this.subscribers.has(type)) {
      this.subscribers.set(type, new Set());
    }
    this.subscribers.get(type).add(callback);
  }

  unsubscribe(type, callback) {
    if (this.subscribers.has(type)) {
      this.subscribers.get(type).delete(callback);
    }
  }

  notifySubscribers(type, data) {
    if (this.subscribers.has(type)) {
      this.subscribers.get(type).forEach(callback => callback(data));
    }
  }

  // Subscribe to specific talent's schedule
  subscribeTalentSchedule(talentId) {
    if (this.socket) {
      this.socket.emit('subscribe:talent-schedule', talentId);
    }
  }

  // Subscribe to booking processing updates
  subscribeToBookingProcessing(bookingId) {
    if (this.socket) {
      this.socket.emit('subscribe:booking-processing', bookingId);
    }
  }

  // Unsubscribe from booking processing updates
  unsubscribeFromBookingProcessing(bookingId) {
    if (this.socket) {
      this.socket.emit('unsubscribe:booking-processing', bookingId);
    }
  }

  // Unsubscribe from specific talent's schedule
  unsubscribeTalentSchedule(talentId) {
    if (this.socket) {
      this.socket.emit('unsubscribe:talent-schedule', talentId);
    }
  }
}

export const websocketService = new WebSocketService(); 